import React, { useEffect, useState } from 'react';
import discountService from '../../_services/discount.service';
import { isOwnerHere } from './access';
import { setCachedManualRule } from '../discounts/manualRule';
import toast from '../shared/Toast';

/**
 * Team › Permissions: what happens when someone sells below the menu price
 * (beu-node-v2 discount/manualDiscount.js). Either way it's recorded in
 * Reports › Manual Discounts. Only the owner changes it.
 */
const OPTIONS = [
  { rule: 'log', title: 'Record it', hint: 'Anyone who can take payment can lower a price. Every sale below the menu shows in Reports › Manual Discounts.' },
  { rule: 'refuse', title: 'Only people with Discounts', hint: 'Staff whose role doesn’t include Discounts can’t lower the price on someone else’s sale. Their own sales, and staff with no role chosen yet, are unaffected.' },
];

export default function BelowMenuRule() {
  const [rule, setRule] = useState(null);
  const [saving, setSaving] = useState(false);
  const owner = isOwnerHere();

  useEffect(() => {
    let live = true;
    discountService.manualRule()
      .then((r) => { if (live) setRule(r && r.rule === 'refuse' ? 'refuse' : 'log'); })
      .catch(() => { if (live) setRule('log'); });
    return () => { live = false; };
  }, []);

  const choose = async (next) => {
    if (!owner || saving || next === rule) return;
    const before = rule;
    setRule(next);
    setSaving(true);
    try {
      const r = await discountService.setManualRule(next);
      setCachedManualRule(r && r.rule);
      toast.success(next === 'refuse' ? 'Only people with Discounts can lower a price now.' : 'Lower prices are recorded, not stopped.');
    } catch (e) {
      setRule(before);
      toast.error((e && e.message) || 'That didn’t save. Try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="settings-card">
      <div className="settings-card-header">
        <h2>Selling below the menu price</h2>
        <p>Typing a lower price, or taking money off a sale, is a discount. Discount codes are tracked separately and don’t count here.</p>
      </div>
      {rule && (
        <div className="perm-below-menu">
          {OPTIONS.map((o) => (
            <label key={o.rule} className={`settings-radio-option${rule === o.rule ? ' selected' : ''}${owner ? '' : ' is-readonly'}`}>
              <span>
                <p>{o.title}</p>
                <small>{o.hint}</small>
              </span>
              <input type="radio" name="belowMenuRule" checked={rule === o.rule} disabled={!owner || saving} onChange={() => choose(o.rule)} />
            </label>
          ))}
          {!owner && <p className="perm-aside">Only the salon owner can change this.</p>}
        </div>
      )}
    </div>
  );
}
